import classNames from 'classnames';
import { parseISO } from 'date-fns';
import addMonths from 'date-fns/addMonths';
import startOfMonth from 'date-fns/startOfMonth';
import subMonths from 'date-fns/subMonths';
import React, { useState } from 'react';
import { TODAY_STRING } from '~/timeConstants';

import DatePickerHeader from './DatePickerHeader';
import DatePickerMonth from './DatePickerMonth';

const CSS = require('./MultiDayDatePicker.module.scss');

interface MultiDayDatePickerProps {
  selectedStartDate?: string;
  selectedEndDate?: string;
  onDateChange: (newDate: string) => void;
  showTwoMonths?: boolean;
  variant?: 'pink' | 'jade';
}

function MultiDayDatePicker({
  selectedStartDate,
  selectedEndDate,
  onDateChange,
  showTwoMonths,
  variant = 'pink',
}: MultiDayDatePickerProps) {
  const [displayedMonth, setDisplayedMonth] = useState(
    startOfMonth(parseISO(selectedStartDate || TODAY_STRING)),
  );
  const onPreviousMonth = () => setDisplayedMonth(subMonths(displayedMonth, 1));
  const onNextMonth = () => setDisplayedMonth(addMonths(displayedMonth, 1));

  const parsedSelectedStartDate = selectedStartDate
    ? parseISO(selectedStartDate)
    : undefined;
  const parsedSelectedEndDate = selectedEndDate
    ? parseISO(selectedEndDate)
    : undefined;

  const nextMonth = addMonths(displayedMonth, 1);

  return (
    <section
      className={classNames({ [CSS.TwoMonthDatePicker]: showTwoMonths })}
    >
      <div>
        <DatePickerHeader
          displayedMonth={displayedMonth}
          onPrevious={onPreviousMonth}
          onNext={!showTwoMonths && onNextMonth}
          showTwoMonths={showTwoMonths}
        />
        <DatePickerMonth
          displayedMonth={displayedMonth}
          selectedStartDate={parsedSelectedStartDate}
          selectedEndDate={parsedSelectedEndDate}
          onDateChange={onDateChange}
          variant={variant}
        />
      </div>
      {showTwoMonths && (
        <div>
          <DatePickerHeader
            displayedMonth={nextMonth}
            onNext={onNextMonth}
            showTwoMonths={showTwoMonths}
          />
          <DatePickerMonth
            displayedMonth={nextMonth}
            selectedStartDate={parsedSelectedStartDate}
            selectedEndDate={parsedSelectedEndDate}
            onDateChange={onDateChange}
            variant={variant}
          />
        </div>
      )}
    </section>
  );
}

export default MultiDayDatePicker;
